import { Box } from "@chakra-ui/react";
import { useStyleConfig } from "@chakra-ui/system";
import React from "react";

type CustomBoxProps = {
    variant: string;
    children: any;
}

const CustomBox = ({ variant, children, ...rest } : CustomBoxProps) => {

  const styles = useStyleConfig("MyBox", { variant });

  return (
    <Box __css={styles} {...rest}>
      {children}
    </Box>
  );
};

export default CustomBox;
